module.exports = __webpack_public_path__ + "static/img/pc-web-img@t.1aee0b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/partecs/pc-web-img@t.png
// module id = UpcA
// module chunks = 0